import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { Result } from 'redux/schemas/api';
import { ComponentType, LectureComponent } from 'redux/schemas/models/lecture-component';

export type FlipCardUpsertAttributes = {
  id?: number,
  frontBody?: string,
  backBody?: string,
  index?: number,
};

interface UpdateFlipCardDeckRequest {
  catalogId: string;
  lecturePageId: number;
  lectureComponentId: number;
  index: number;
  flipCardDeckId?: number;
  cards: FlipCardUpsertAttributes[];
}

export const updateFlipCardDeckLectureComponent = createAsyncThunk<
LectureComponent<ComponentType.FLIP_CARD>,
UpdateFlipCardDeckRequest
>('UPDATE_FLIP_CARD_DECK_LECTURE_COMPONENT', async (params) => {
  const data = {
    lectureComponent: {
      id: params.lectureComponentId,
      index: params.index,
      onlyDownstreamOutlineUpdate: false,
      type: ComponentType.FLIP_CARD,
      trueType: ComponentType.FLIP_CARD,
      flipCardDeck: {
        ...(params.flipCardDeckId ? { id: params.flipCardDeckId } : {}),
        flipCardsAttributes: params.cards,
      },
    },
    format: 'json',
  };

  const response = await axios.put<Result<LectureComponent<ComponentType.FLIP_CARD>>>(
    `/${params.catalogId}/lecture_pages/${params.lecturePageId}/flip_card_deck_lecture_component/${params.lectureComponentId}`,
    data,
  );

  return response.data.result;
});
